import { UTMParameters } from '@/types';

import { UTM_PARAMS } from './storage';

export const extractUTMParameters = (url: string | URL): UTMParameters => {
  let urlObject: URL;

  try {
    urlObject = typeof url === 'string' ? new URL(url) : url;
  } catch (error) {
    console.error('Invalid URL provided:', error);
    return {};
  }

  const params = urlObject.searchParams;

  return {
    utmSource: params.get(UTM_PARAMS.UTM_SOURCE) || undefined,
    utmMedium: params.get(UTM_PARAMS.UTM_MEDIUM) || undefined,
    utmCampaign: params.get(UTM_PARAMS.UTM_CAMPAIGN) || undefined,
    utmContent: params.get(UTM_PARAMS.UTM_CONTENT) || undefined,
    utmCampaignId: params.get(UTM_PARAMS.UTM_CAMPAIGNID) || undefined,
    utmAdGroupId: params.get(UTM_PARAMS.UTM_ADGROUPID) || undefined,
    utmTerm: params.get(UTM_PARAMS.UTM_TERM) || undefined,
    utmDevice: params.get(UTM_PARAMS.UTM_DEVICE) || undefined,
    utmMatchType: params.get(UTM_PARAMS.UTM_MATCHTYPE) || undefined,
    utmAdPosition: params.get(UTM_PARAMS.UTM_ADPOSITION) || undefined,
    gclid: params.get(UTM_PARAMS.UTM_GCLID) || undefined,
  };
};
